import { render, staticRenderFns } from "./Medicalreport.vue?vue&type=template&id=76c93998&"
import script from "./Medicalreport.vue?vue&type=script&lang=js&"
export * from "./Medicalreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports